(function () {
  'use strict';

  /* Mobile menu toggle */
  document.addEventListener('DOMContentLoaded', function () {
    var toggle = document.querySelector('[data-menu-toggle]');
    var nav = document.querySelector('[data-mobile-nav]');
    if (toggle && nav) {
      toggle.addEventListener('click', function () {
        nav.classList.toggle('is-open');
      });
    }

    initProductGallery();
    initReviewsCarousel();
    initVariantSelectors();
    initScrollReveal();
    initSearchBar();
    initCollectionSort();
  });

  /* Product gallery */
  function initProductGallery() {
    var gallery = document.querySelector('[data-product-gallery]');
    if (!gallery) return;
    var images = gallery.querySelectorAll('.product-gallery__image');
    var thumbs = gallery.querySelectorAll('.product-gallery__thumb');
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var index = thumb.dataset.index;
        images.forEach(function (img) { img.classList.remove('is-active'); });
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        var target = gallery.querySelector('.product-gallery__image[data-index="' + index + '"]');
        if (target) target.classList.add('is-active');
        thumb.classList.add('is-active');
      });
    });
  }

  /* Reviews carousel — auto-sliding 3-by-3, smooth, pauses on hover */
  function initReviewsCarousel() {
    var carousel = document.querySelector('[data-reviews-carousel]');
    if (!carousel) return;
    var track = carousel.querySelector('[data-track]');
    if (!track) return;
    var cards = Array.prototype.slice.call(track.children);
    if (!cards.length) return;

    track.style.display = 'flex';
    track.style.transition = 'transform 0.8s cubic-bezier(0.65, 0, 0.35, 1)';
    track.style.willChange = 'transform';

    var perView = window.innerWidth < 900 ? 1 : 3;
    cards.forEach(function (c) {
      c.style.flex = '0 0 ' + (100 / perView) + '%';
      c.style.boxSizing = 'border-box';
    });

    var dotsWrap = document.querySelector('[data-dots]');
    var prevBtn  = carousel.querySelector('[data-prev]');
    var nextBtn  = carousel.querySelector('[data-next]');

    var AUTO_INTERVAL = 5000;
    var totalPages = Math.max(1, Math.ceil(cards.length / perView));
    var index = 0;
    var timer = null;

    function render() {
      track.style.transform = 'translateX(-' + (index * 100) + '%)';
      if (dotsWrap) {
        dotsWrap.innerHTML = '';
        for (var i = 0; i < totalPages; i++) {
          var dot = document.createElement('button');
          dot.className = 'reviews-carousel__dot' + (i === index ? ' is-active' : '');
          dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
          (function (i) {
            dot.addEventListener('click', function () { goTo(i); restart(); });
          })(i);
          dotsWrap.appendChild(dot);
        }
      }
    }

    function goTo(i)   { index = (i + totalPages) % totalPages; render(); }
    function goNext()  { goTo(index + 1); }
    function goPrev()  { goTo(index - 1); }

    function start() {
      if (totalPages <= 1) return;
      stop();
      timer = setInterval(goNext, AUTO_INTERVAL);
    }
    function stop()    { if (timer) { clearInterval(timer); timer = null; } }
    function restart() { start(); }

    if (prevBtn) prevBtn.addEventListener('click', function () { goPrev(); restart(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goNext(); restart(); });

    carousel.addEventListener('mouseenter', stop);
    carousel.addEventListener('mouseleave', start);
    carousel.addEventListener('focusin',    stop);
    carousel.addEventListener('focusout',   start);

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop(); else start();
    });

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        var newPerView = window.innerWidth < 900 ? 1 : 3;
        if (newPerView !== perView) {
          perView = newPerView;
          cards.forEach(function (c) { c.style.flex = '0 0 ' + (100 / perView) + '%'; });
          totalPages = Math.max(1, Math.ceil(cards.length / perView));
          index = 0;
          render();
        }
      }, 150);
    });

    render();
    start();
  }

  /* Variant selectors */
  function initVariantSelectors() {
    var form = document.querySelector('.product-form');
    if (!form) return;
    var selects = form.querySelectorAll('[data-option-index]');
    var idInput = form.querySelector('[data-variant-id]');
    if (!selects.length || !idInput) return;

    var product = window.__product;
    if (!product) return;

    function updateVariant() {
      var values = Array.prototype.map.call(selects, function (s) { return s.value; });
      var match = product.variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === values[i]; });
      });
      if (match) idInput.value = match.id;
    }

    selects.forEach(function (s) {
      s.addEventListener('change', updateVariant);
    });
  }

  /* Scroll reveal — animates elements as they enter the viewport */
  function initScrollReveal() {
    var selectors = [
      '.reveal',
      '.section-heading', '.section-subheading',
      '.hero__eyebrow', '.hero__heading', '.hero__subheading', '.hero__cta',
      '.about-section__body',
      '.featured-product__heading', '.featured-product__body',
      '.featured-product__price', '.featured-product .btn',
      '.feature-card', '.review-card', '.faq-item'
    ];
    var elements = document.querySelectorAll(selectors.join(','));
    if (!elements.length) return;

    if (!('IntersectionObserver' in window)) {
      elements.forEach(function (el) { el.classList.add('is-revealed'); });
      return;
    }

    var observer = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          obs.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.30,
      rootMargin: '0px 0px -120px 0px'
    });

    elements.forEach(function (el) { observer.observe(el); });
  }

  /* Search page — re-submit form when sort changes */
  function initSearchBar() {
    var bar = document.querySelector('[data-search-bar]');
    if (!bar) return;
    var sortSelect = bar.querySelector('[data-sort-select]');
    if (!sortSelect) return;
    sortSelect.addEventListener('change', function () {
      bar.querySelector('[data-search-form]').submit();
    });
  }

  /* Collection page — update URL sort_by param when sort changes */
  function initCollectionSort() {
    var select = document.querySelector('[data-collection-sort]');
    if (!select) return;
    select.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

})();
